module.exports = [
  {
    id: 'webiomedmpi',
    name: 'Анализатор запросов'
  },
  {
    id: 'medical',
    name: 'Пациенты в dataset и отобранные коллекции'
  },
  {
    id: 'analytics',
    name: 'Отчёты'
  },
  {
    id: 'nsi',
    name: 'Справочники'
  },
  {
    id: 'system',
    name: 'Пользователи и группы'
  },
  {
    id: 'monitoring',
    name: 'Журнал'
  }
]
